/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import DateDropDown from '../../operations/common/datedropdown';
import { AmountStatusDropdown } from '../../operations/common/dropdowns';
import RefreshButton from '../../common/refreshbutton';
import DownloadPayrollCSVButton from './DownloadPayrollCSVButton';
import ClientSearch from '../../operations/common/clientsearch';
import history from '../../../history';
import SearchBar from '../../operations/common/SearchBar';
import { SelectRole } from '../../common/SelectRole';


export default class PayrollFilters extends Component {
    state = {
        // eslint-disable-next-line react/no-unused-state
        query: {},
    };

    onFilterChange = (id, value) => {
        this.props.onFilterChange(id, value);
    };

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="table-filter-container payroll-filter-container">
                <DateDropDown
                    onFilterChange={this.onFilterChange}
                    history={history}
                    mode="payroll"
                />
                <SelectRole
                    onFilterChange={this.onFilterChange}
                    currentUrlParams={currentUrlParams}
                />
                <AmountStatusDropdown
                    onFilterChange={this.onFilterChange}
                    history={history}
                />
                <ClientSearch history={history} />
                <SearchBar
                    customPlaceHolder="Cost centre number..."
                    filterKey="bookings_cost_centre"
                    onFilterChange={this.onFilterChange}
                    currentUrlParams={currentUrlParams}
                    inputType="number"
                    maxInputLength={3}
                />
                <div className="table-action-bar">
                    <RefreshButton reloadData={this.props.reloadData} />
                    <DownloadPayrollCSVButton
                        history={history}
                        endpoint="freelancers"
                        notification={this.props.notification}
                    />
                </div>
            </div>
        );
    }
}
